module.exports = "<app-header></app-header>\r\n<router-outlet></router-outlet>\r\n<app-footer></app-footer>\r\n<simple-notifications [options]=\"notificationOptions\"></simple-notifications>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/PRO/Documents/GitHub/CGStore-Front/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main